
export const LEAD_REQUEST="LEAD_REQUEST"
export const GET_LEAD_SUCCESS="GET_LEAD_SUCCESS"
export const PUT_LEAD_SUCCESS="PUT_LEAD_SUCCESS"
export const DELETE_LEAD_SUCCESS="DELETE_LEAD_SUCCESS"
export const LEAD_FAILURE="LEAD_FAILURE"